define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/action",
	"csi/action/FormData",
	"csi/table/New",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"BusinessPlanning/ProductPlanProductMixin"
], function(array,declare,action,FormData,New,ActionControllerMixin,xml,ProductPlanProductMixin) {

	return declare([New, ActionControllerMixin, ProductPlanProductMixin], {
		_fdProduct: null,
		_fdPage2: null,

		constructor: function(/*Object*/params) {
			var actionId = this.m_action.m_id;
			if(actionId == "NewBPProductPlanFromStyleSize") {
				this.productClass = this._STYLE;
				this.__aggregateClassId = this._PRODUCT_SIZE;
			} else if(actionId == "NewBPProductPlanFromMaterialSize") {
				this.productClass = this._MATERIAL;
				this.__aggregateClassId = this._PRODUCT_SIZE;
			}
		},

		getWizardViewQuery: function(/*csi.wizard.Widget*/wizard, /*csi.view.Widget*/view, /*Number*/index) {
			// summary: apply filters to wizard views
			if (index == 0) {
				// filter out products by filters defined on the BusinessPlan
				return this._getQuery();
			}

			return null;
		},

		onNextPage: function(/*csi.wizard.Widget*/wizard,
							 /*csi.wizard.Content*/currentPage,
							 /*csi.wizard.Content*/nextPage,
							 /*Boolean*/bFinish) {
			// summary: prepare the data and pass it into the next page
			var indexOfPage = wizard.getIndexOfPage(nextPage);
			var	bRefresh = false;
			var	dfd, fd;

			if (indexOfPage == 0) {
				// moving to Products table
				fd = this._fdProduct = this._fdProduct || this.m_formData;
				fd.m_bRequireOne = true;
				fd.m_bSelectOne = true;
			} else if (indexOfPage == 1) {
				// moving to ProductSizes table view of selected Product
				var	product = wizard.getFormDataFromPage(currentPage).getSelectedNode();

				// initialize form data
				fd = this._fdPage2 = this._fdPage2 || new FormData(this);
				if (fd.getNode() != product) {
					fd.setNode(product);
					fd.resetAggregations();
					fd.resetSelections();
					bRefresh = true;
				}
				fd.m_bRequireOne = true;
			}

			return fd ? wizard.setFormDataToPage(nextPage, fd, bRefresh) : null;
		},

		toWriterRequest: function() {
			// summary: handle request for second page
			var	call = this.inherited(arguments);

			var adds = this._fdPage2 ? this._fdPage2.getSelectedNodes(true) : null;
			if (adds)
				call.addParameter(xml.PROP_AGGREGATE_ADDS, xml.ATTR_REFLIST, array.map(adds, xml.nodeGetURL));

			return call;
		},

		postProcessSuccess: function() {
			// summary: refresh data in where used table
			this.widget.refreshData();
		}
	});
});